const routes = [
  {
    path: '/personControl', // 布控管理
    name: 'personControl',
    component: () => import('./view/Home'),
    meta: {
      requireAuth: false
    },
    children: [{
      path: 'manage', // 布控管理
      name: 'controManage',
      component: () => import('./view/personCm'),
      meta: {
        requireAuth: false
      }
    }, {
      path: 'create', // 创建布控
      name: 'controlCreate',
      component: () => import('./view/Create'),
      meta: {
        requireAuth: false
      }
    }, {
      path: 'edit', // 修改布控
      name: 'controlEdit',
      component: () => import('./view/Edit'),
      meta: {
        requireAuth: false
      }
    }]
  }
]

export default routes